import React from 'react';
import { findTab } from './tabConfig';
import { useWorkspaceDevice } from './workspaceContext';

/**
 * Plan 94 Phase 1 - placeholder for tabs whose per-device pages have not yet been
 * adapted to the route-bound workspace (Phase 2 wires Analyze/Notes/Debug/Photos/
 * Settings/App-Claims to the resolved device). Keeps the shell navigable and
 * shippable before those refactors land.
 */
const TabPlaceholder: React.FC<{ tabKey: string }> = ({ tabKey }) => {
  const { device } = useWorkspaceDevice();
  const tab = findTab(tabKey);

  return (
    <div className="bg-card border border-border rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold">{tab?.label ?? tabKey}</h3>
      <p className="mt-2 text-sm text-muted-foreground">
        The {tab?.label ?? tabKey} tool for{' '}
        <span className="font-mono">{device.name}</span> ({device.id}) is moving
        here. Until then use the existing page from the navbar.
      </p>
    </div>
  );
};

export default TabPlaceholder;
